import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITopupRequest, ITopupRequestState } from "./topupRequestModel";
import {
  deleteTopupRequest,
  getAllTopupRequests,
  getTopupRequestByID,
  insertTopupRequest,
  updateTopupRequest,
  updateTopupRequestStatus,
} from "./services/topuprequest.services";

const initialState: ITopupRequestState = {
  loading: false,
  formLoading: false,
  error: "",
  TopupRequestList: [],
  TopupRequestID: null,
  TopupRequestDetails: {
    AccHoloderName: "",
    AccountNo: "",
    Amount: null,
    BankID: null,
    ChequeBranchName: "",
    ChequeNo: "",
    CustomerID: null,
    DepositedBankID: null,
    DepositedBranch: "",
    DepositedMode: "",
    EmployeeID: null,
    NetTransferID: "",
    Remarks: "",
    TransactionDate: "",
    TransactionNo: "",
    Type: "Cheque",
  },
  TopupRequestFilterDetails: {
    FromDate: "",
    ToDate: "",
    DepositedBank: "",
    RequestStatus: "",
    Name: "",
    MobileNo: "",
    FromAmount: 0,
    ToAmount: 0,
    Type: "",
  },
};

const topupRequestSlice = createSlice({
  name: "topuprequest",
  initialState,
  reducers: {
    setTopupRequestFilter: (state, action) => {
      state.TopupRequestFilterDetails = action.payload;
    },
    clearTopupRequestFilter: (state) => {
      state.TopupRequestFilterDetails = initialState.TopupRequestFilterDetails;
    },
    clearTopupRequestDetails: (state) => {
      state.TopupRequestDetails = initialState.TopupRequestDetails;
    },
    setTopupRequestID: (state, action) => {
      state.TopupRequestID = action.payload;
    },
    clearTopupRequestID: (state) => {
      state.TopupRequestID = initialState.TopupRequestID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTopupRequests.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTopupRequests.fulfilled,
      (state, action: PayloadAction<ITopupRequest[]>) => {
        state.loading = false;
        state.TopupRequestList = action.payload || [];
      }
    );
    builder.addCase(getAllTopupRequests.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TopupRequestList = [];
    });
    builder.addCase(updateTopupRequestStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateTopupRequestStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateTopupRequestStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getTopupRequestByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTopupRequestByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TopupRequestDetails = action.payload;
    });
    builder.addCase(getTopupRequestByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TopupRequestDetails = initialState.TopupRequestDetails;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(insertTopupRequest.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertTopupRequest.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertTopupRequest.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTopupRequest.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateTopupRequest.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTopupRequest.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTopupRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTopupRequest.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTopupRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearTopupRequestID,
  setTopupRequestID,
  setTopupRequestFilter,
  clearTopupRequestFilter,
  clearTopupRequestDetails,
} = topupRequestSlice.actions;
export default topupRequestSlice.reducer;
